var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c(
        "div",
        { staticClass: "detail-map-container" },
        [
          _c("tecno-map", {
            ref: "map",
            staticClass: "detail-map",
            attrs: { options: _vm.options }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "poiController",
            attrs: { id: "detail-map-poi-controller" }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }